import { jsxs as t, Fragment as l, jsx as r } from "react/jsx-runtime";
const o = () => /* @__PURE__ */ t(l, { children: [
  /* @__PURE__ */ r(
    "path",
    {
      d: "M3 4C3 2.34315 4.34315 1 6 1H12.5V5.5C12.5 7.70914 14.2909 9.5 16.5 9.5H21V20C21 21.6569 19.6569 23 18 23H5C3.89543 23 3 22.1046 3 21V4Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ r(
    "path",
    {
      d: "M20.9824 7.5C20.7377 4.03251 17.9675 1.2623 14.5 1.01758V5.5C14.5 6.60457 15.3954 7.5 16.5 7.5H20.9824Z",
      fill: "currentColor"
    }
  )
] });
export {
  o as default
};
